const MAX_ENTRIES = 100;
const buffer = [];
let installed = false;

function addEntry(level, args) {
  const message = args
    .map(a => {
      try { return typeof a === 'object' ? JSON.stringify(a) : String(a); }
      catch { return String(a); }
    })
    .join(' ');
  buffer.push({ level, message, timestamp: Date.now() });
  if (buffer.length > MAX_ENTRIES) buffer.shift();
}

export function installLogBuffer() {
  if (installed) return;
  installed = true;

  const origError = console.error.bind(console);
  const origWarn = console.warn.bind(console);

  console.error = (...args) => { addEntry('error', args); origError(...args); };
  console.warn  = (...args) => { addEntry('warn',  args); origWarn(...args); };

  const origFetch = window.fetch;
  if (origFetch) {
    window.fetch = async (...args) => {
      const response = await origFetch(...args);
      if (!response.ok) {
        addEntry('network', [`${response.status} ${response.statusText}`, String(args[0])]);
      }
      return response;
    };
  }
}

export function getLogBuffer() {
  return [...buffer];
}

export function clearLogBuffer() {
  buffer.length = 0;
}

export function resetLogBuffer() {
  buffer.length = 0;
  installed = false;
}
